import React from 'react';
import * as Grid from '@bubble-ui/particle-grid';
import Shape from '@bubble-ui/primitive-shape';
import toPath from './toPath';

var VerticalLine = function VerticalLine(_ref) {
  var position = _ref.position,
      invertedColor = _ref.invertedColor,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(Shape, {
    d: toPath([[Grid.SIZE * position - 0.5, 0], [Grid.SIZE * position - 0.5, height], [Grid.SIZE * position, height], [Grid.SIZE * position, 0]]),
    fill: position % 2 === 0 ? invertedColor ? 'rgba(0, 255, 255, 1)' : 'rgba(0, 85, 0, 1)' : invertedColor ? 'rgba(0, 255, 255, 0.5)' : 'rgba(255, 85, 0, 0.5)'
  });
};

export default VerticalLine;
//# sourceMappingURL=VerticalLine.js.map